import React from "react";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import txMapWhite from "../../../Assets/tx-map-white.png";
import ftSkyline from "../../../Assets/ft-skyline.png";
import Image from "mui-image";

import Cat1 from "../../../Assets/forth-cat-1.png";
import Cat2 from "../../../Assets/forth-cat-2.png";
import Holiday from "../../../Assets/ftworth-special.png";
import Trad from "../../../Assets/fort-trad.png";

const MenuContent = () => {
  return (
    <Box sx={{ py: 5 }}>
      <Box
        sx={{
          py: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Card
          sx={{
            width: { md: "95%", lg: "60%" },
          }}
        >
          <CardMedia
            component="img"
            sx={{
              height: { xs: "auto", md: "auto" },
              objectFit: { xs: "fill", md: "contain" },
              border: "5px solid #ffff",
              borderRadius: "10px",
            }}
            image={Holiday}
          />
        </Card>
      </Box>
      <Box
        sx={{
          py: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Card
          sx={{
            width: { md: "95%", lg: "60%" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: { xs: "column", md: "row" },
              border: "5px solid #ffff",
              borderRadius: "10px",
            }}
          >
            <CardMedia
              component="img"
              sx={{
                height: { xs: "auto", md: "auto" },

                objectFit: { xs: "fill", md: "contain" },
              }}
              image={Cat1}
            />

            <CardMedia
              component="img"
              sx={{
                height: { xs: "auto", md: "auto" },
                objectFit: { xs: "fill", md: "contain" },
              }}
              image={Cat2}
            />
          </Box>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" color="text.secondary">
              Enjoy the best BBQ meal
            </Typography>
            <Button
              href="https://drive.google.com/file/d/1zFXAePs2gOKnXL3X0mhaiKCk28x78Poy/view?usp=share_link"
              sx={{
                textAlign: "center",
                width: "50%",
              }}
              variant="outlined"
              size="large"
              color="secondary"
            >
              Download Menu
            </Button>
          </CardContent>
        </Card>
      </Box>
      <Box sx={{ p: { xs: 0, md: 4 } }}>
        <Image
          src={ftSkyline}
          style={{ maxHeight: "350px", maxWidth: " 00px" }}
        />
      </Box>
      {/* <Box
        sx={{
          py: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Card
          sx={{
            width: { md: "95%", lg: "60%" },
          }}
        >
          <CardMedia
            component="img"
            sx={{
              height: { xs: "auto", md: "130vh" },
              objectFit: { xs: "fill", md: "fill" },
              border: "5px solid #ffff",
              borderRadius: "10px",
            }}
            image={Cat2}
          />
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" color="text.secondary">
              Enjoy the best BBQ meal
            </Typography>
            <Button
              href="https://drive.google.com/file/d/1mtP192qhHxM7EbM1wm7BWqvoGfQVe-ge/view?usp=sharing"
              sx={{
                textAlign: "center",
                width: "50%",
              }}
              variant="outlined"
              size="large"
              color="secondary"
            >
              Download Menu
            </Button>
          </CardContent>
        </Card>
      </Box> */}
      <Box sx={{ p: { xs: 0, md: 4 } }}>
        <Image src={txMapWhite} style={{ height: "300px", width: "300px" }} />
      </Box>
      <Box
        sx={{
          p: 2,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <Typography sx={{ p: 2 }} variant="h2">
          Available Now <br /> Nov 14, 2024 - Jan 1, 2025
        </Typography> */}
        <Typography sx={{ p: 2, width: "60%" }} variant="h4">
          Fine Authentic Texas BBQ Holiday Meals are available with 48hrs
          advance notice.
        </Typography>
      </Box>
      {/* <Box
        sx={{
          py: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Card
          sx={{
            width: { md: "95%", lg: "60%" },
          }}
        >
          <CardMedia
            component="img"
            sx={{
              height: { xs: "auto", md: "auto" },
              objectFit: { xs: "fill", md: "contain" },
              border: "5px solid #ffff",
              borderRadius: "10px",
            }}
            image={Trad}
          />
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" color="text.secondary">
              Enjoy the best BBQ meal
            </Typography>
            <Button
              href="https://drive.google.com/file/d/1KXzVx6sTlk1ivgE7-sS9TnEb93tU-dRw/view?usp=drive_link"
              sx={{
                textAlign: "center",
                width: "50%",
              }}
              variant="outlined"
              size="large"
              color="secondary"
            >
              Download Menu
            </Button>
          </CardContent>
        </Card>
      </Box> */}
    </Box>
  );
};

export default MenuContent;
